import { useFetch } from '../../hooks/useFetch';

/**
 * @param {import('../../types/dashboard').DashboardRefreshParams} [params]
 * @returns {Promise<import('../../types/dashboard').DashboardSystem>}
 */
export const FetchDashboardSystem = async (params) => {
  const body = await useFetch('/dashboard/system', params);

  return body.data;
};
